import { Link, useLocation } from "react-router-dom";
import SEOHead from "@/components/SEOHead";
import { CheckCircle2, Home, Bot } from "lucide-react";

export default function ThankYou() {
  const { state } = useLocation();
  const kind = state?.kind;
  const msg =
    kind === "expert"
      ? "Your expert counseling request is confirmed. Our admission expert will call you to finalize your slot."
      : kind === "contact"
      ? "Thanks for reaching out! Our team will get back to you shortly."
      : "Your request has been received. We'll be in touch soon.";

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center" data-testid="thank-you-page">
      <SEOHead title="Thank You" />
      <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#10B981]/10">
        <CheckCircle2 className="h-12 w-12 text-[#10B981]" />
      </span>
      <h1 className="mt-6 text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">Thank You!</h1>
      <p className="mt-4 text-slate-600 leading-relaxed">{msg}</p>
      <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
        <Link to="/" data-testid="thankyou-home-btn" className="inline-flex items-center justify-center gap-2 rounded-lg bg-[#0B2A6B] px-6 py-3 text-sm font-semibold text-white hover:bg-[#081E4D]">
          <Home className="h-4 w-4" /> Back to Home
        </Link>
        <Link to="/ai-counseling" className="inline-flex items-center justify-center gap-2 rounded-lg border-2 border-[#0B2A6B] px-6 py-3 text-sm font-semibold text-[#0B2A6B] hover:bg-slate-50">
          <Bot className="h-4 w-4" /> Try Free AI Counseling
        </Link>
      </div>
    </div>
  );
}
